
import { useState } from 'react';
import Button from '../../../components/base/Button';

export default function ContactSection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!formData.name || !formData.email || !formData.message) {
      setError('Veuillez remplir tous les champs obligatoires');
      return;
    }

    setIsSubmitting(true);
    setError('');

    try {
      const formDataToSend = new FormData();
      formDataToSend.append('name', formData.name);
      formDataToSend.append('email', formData.email);
      formDataToSend.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d44ii0upguuav66rgh60', {
        method: 'POST',
        body: formDataToSend,
      });

      if (response.ok) {
        setSuccess(true);
        setFormData({
          name: '',
          email: '',
          message: ''
        });
      } else {
        setError('Erreur lors de l\'envoi. Veuillez réessayer.');
      }
    } catch (error) {
      setError('Erreur de connexion. Veuillez réessayer.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section id="contact" className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-black mb-4">
            Restons en Contact
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-[#FF6B35] to-[#FF8A65] mx-auto mb-6"></div>
          <p className="text-xl text-gray-600">
            Pour des partenariats, collaborations ou un accès privé :
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Info */}
          <div className="space-y-8">
            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 bg-gradient-to-r from-[#FF6B35] to-[#FF8A65] rounded-full flex items-center justify-center">
                <i className="ri-mail-line text-white text-xl"></i>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-black">Email</h3>
                <p className="text-gray-600">Adel@maisonzeus.com</p>
              </div>
            </div>

            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 bg-gradient-to-r from-[#FF6B35] to-[#FF8A65] rounded-full flex items-center justify-center">
                <i className="ri-whatsapp-line text-white text-xl"></i>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-black">WhatsApp Business</h3>
                <a href="https://wa.me/33658126340" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-[#FF6B35] transition-colors">
                  +33 6 58 12 63 40
                </a>
              </div>
            </div>
            
            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 bg-gradient-to-r from-[#FF6B35] to-[#FF8A65] rounded-full flex items-center justify-center">
                <i className="ri-map-pin-line text-white text-xl"></i>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-black">Localisation</h3>
                <p className="text-gray-600">Paris • Dubaï • Monde entier</p>
              </div>
            </div>
            
            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 bg-gradient-to-r from-[#FF6B35] to-[#FF8A65] rounded-full flex items-center justify-center">
                <i className="ri-time-line text-white text-xl"></i>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-black">Disponibilité</h3>
                <p className="text-gray-600">Lun - Ven, 9h - 18h CET</p>
              </div>
            </div>
          </div>
          
          {/* Contact Form */}
          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <form 
              onSubmit={handleSubmit} 
              className="space-y-6"
              data-readdy-form="contact-home-section"
            >
              <div>
                <label htmlFor="name" className="block text-sm font-semibold text-black mb-2">
                  Nom complet
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6B35] focus:border-transparent transition-all duration-300"
                  required
                />
              </div>
              
              <div>
                <label htmlFor="email" className="block text-sm font-semibold text-black mb-2">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6B35] focus:border-transparent transition-all duration-300"
                  required
                />
              </div>
              
              <div>
                <label htmlFor="message" className="block text-sm font-semibold text-black mb-2">
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows={4}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FF6B35] focus:border-transparent transition-all duration-300 resize-none"
                  required
                ></textarea>
              </div>

              {error && (
                <div className="p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg">
                  {error}
                </div>
              )}

              {success && (
                <div className="p-4 bg-green-100 border border-green-400 text-green-700 rounded-lg">
                  Message envoyé avec succès ! Nous vous répondrons rapidement.
                </div>
              )}
              
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-gradient-to-r from-[#FF6B35] to-[#FF8A65] text-white font-bold py-3 px-6 rounded-lg hover:from-[#FF5722] hover:to-[#FF7043] transition-all duration-300 transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSubmitting ? 'Envoi en cours...' : 'Envoyer le Message'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
